import React from "react";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const prefix = process.env.REACT_APP_STUDENT_PREFIX || "student";

/**
 * Shared chrome for Wizard feature pages (back to hub + title).
 */
export default function WizardPageShell({ title, subtitle, children, maxWidth = "md" }) {
  const navigate = useNavigate();

  return (
    <Container maxWidth={maxWidth} sx={{ py: { xs: 2, md: 3 } }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(`/${prefix}/wizard`)}
        sx={{ mb: 2, textTransform: "none", fontWeight: 600 }}
      >
        Back to Wizard
      </Button>
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: "#0F172A", letterSpacing: -0.3 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body1" sx={{ color: "#64748B", mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 3,
          border: "1px solid #E2E8F0",
          bgcolor: "#fff",
        }}
      >
        {children}
      </Paper>
    </Container>
  );
}
